var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoyaltyWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#C6D0D0;}\n\t.st2{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_408_2_1_);}\n\t.st4{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 64,
    height: 64
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,64c17.7,0,32-14.3,32-32S49.7,0,32,0S0,14.3,0,32S14.3,64,32,64z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 20,
    y: 18.7,
    width: 23.3,
    height: 26.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18.7,
    width: 23.3,
    height: 26.7,
    id: "mask0_408_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.3,18.7H20v26.7h23.3V18.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25,25.3c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7c0-0.3,0-0.6-0.1-0.9c0,0,0-0.1,0-0.1 c-0.5-3.2-3.2-5.7-6.6-5.7c-2.5,0-4.6,1.4-5.8,3.4c0,0,0,0,0,0C25.3,23,25,24.1,25,25.3L25,25.3z M31.7,30.3c-2.8,0-5-2.2-5-5 c0-0.6,0.1-1.1,0.3-1.6c1.9,1.5,4.2,2.4,6.7,2.4h0c1,0,2-0.2,3-0.4C36.4,28.3,34.3,30.3,31.7,30.3L31.7,30.3z M31.7,20.3 c2.3,0,4.2,1.6,4.8,3.7c-0.9,0.3-1.9,0.5-2.9,0.5c-2.2,0-4.3-0.8-5.9-2.2C28.7,21.1,30.1,20.3,31.7,20.3L31.7,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.2,33.7C36.2,33.7,36.1,33.7,36.2,33.7c-1.5-0.6-2.9-0.9-4.5-0.9c-1.6,0-3.1,0.3-4.4,0.9c0,0-0.1,0-0.1,0 C23,35.5,20,39.7,20,44.5c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-3.7,2-6.9,5-8.7c0.3,2.5,2.4,4.5,5,4.5 c2.6,0,4.7-2,5-4.5c3,1.7,5,5,5,8.7c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C43.3,39.7,40.4,35.5,36.2,33.7z M35,35.3 c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3v-0.2c1-0.4,2.2-0.6,3.3-0.6c1.2,0,2.3,0.2,3.3,0.6V35.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyWaiting);
export default __webpack_public_path__ + "static/media/loyalty_waiting.33622f03db0e80d01a9c5551fb071507.svg";
export { ForwardRef as ReactComponent };